import { FunctionComponent } from 'react';
import TitleWithIcon from '../../../../../components/titles/TitleWithIcon/TitleWithIcon';
import { ReactComponent as LayersIcon } from '../../../../../asset/images/icons/layers.svg';
import { ReactComponent as CdLogo } from '../../../../../apps/constellationDinners/asset/images/constellation_dinners_logo.svg';
import styles from './AccountApps.module.scss';
import MetaTags from '../../../../../components/seo/MetaTags/MetaTags';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { RoutesGrouped } from '../../../../../data/routes';
import MainButton from '../../../../../components/buttons/MainButton/MainButton';
import RoutesEnum from '../../../../../enums/routes';
import ShowOnlyInSomeEnv from '../../../../../components/helpers/ShowOnlyInSomeEnv/ShowOnlyInSomeEnv';
import ComingSoonMessage from '../../../../../components/texts/ComingSoonMessage/ComingSoonMessage';

interface AccountSubscriptionProps {}

const AccountApps: FunctionComponent<AccountSubscriptionProps> = () => {
  const navigate = useNavigate();

  return (
    <div className={styles['apps']}>
      <MetaTags title="Account - Apps" />

      <TitleWithIcon
        className={styles['title']}
        icon={<LayersIcon style={{ fill: 'var(--color-main)', width: '29px' }} />}
      >
        <h3 className={'text text--h3'}>Apps</h3>
      </TitleWithIcon>

      <div className="bottom-part">
        <ShowOnlyInSomeEnv showInWhatEnv={['development', 'staging']}>
          <div className={styles['group-list']}>
            <div className={styles['group']}>
              <p className={classNames(styles['title-2'], 'text text--caps')}>Your Apps</p>

              <div className={styles['app-list']}>
                <div
                  className={classNames(styles['app-list__item'], 'tile tile--padding-24px')}
                  onClick={() => navigate(`/${RoutesGrouped.CONSTELLATION_DINNERS_BASE}`)}
                >
                  <div className={styles['app-list__logo']}>
                    <CdLogo />
                  </div>

                  <div className={styles['app-list__info']}>
                    <p className={classNames(styles['app-list__info__title'], 'text text--h5')}>
                      Constellation Dinners
                    </p>

                    <p className={classNames(styles['app-list__info__text'], 'text text--body-3')}>
                      We’ll match you with other founders and investors by industry, business type, revenue stage, and
                      growth goals for spirited topical discussions over a healthy meal.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles['group']}>
              <p className={classNames(styles['title-2'], 'text text--caps')}>Available Apps</p>

              <div className={styles['app-list']}>
                {Array.from({ length: 4 }).map((item, i) => (
                  <div
                    className={classNames(styles['app-list__item'], 'tile tile--padding-24px')}
                    onClick={() => navigate(`/${RoutesEnum.ACCOUNT}/${RoutesEnum.APPS}/detail`)}
                  >
                    <div className={styles['app-list__logo']}>
                      <CdLogo />
                    </div>

                    <div className={styles['app-list__info']}>
                      <p className={classNames(styles['app-list__info__title'], 'text text--h5')}>
                        Constellation Dinners
                      </p>

                      <p className={classNames(styles['app-list__info__text'], 'text text--body-3')}>
                        We’ll match you with other founders and investors by industry, business type, revenue stage, and
                        growth goals for spirited topical discussions over a healthy meal.
                      </p>
                    </div>

                    <MainButton className={styles['app-list__button']} visualType="white" sizeType="medium">
                      View details
                    </MainButton>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </ShowOnlyInSomeEnv>

        <ShowOnlyInSomeEnv showInWhatEnv={['production']}>
          <ComingSoonMessage />
        </ShowOnlyInSomeEnv>
      </div>
    </div>
  );
};

export default AccountApps;
